import { render, staticRenderFns } from "./newfx.vue?vue&type=template&id=2d9aedef&scoped=true&"
import script from "./newfx.vue?vue&type=script&lang=js&"
export * from "./newfx.vue?vue&type=script&lang=js&"
import style0 from "./newfx.vue?vue&type=style&index=0&id=2d9aedef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9aedef",
  null
  
)

export default component.exports